import { DeliveryContent } from '../types/VDPTypes';

const deliveryContent: DeliveryContent = {
  'very.onePersonContent.pageText':
    'FREE standard delivery with Click & Collect on orders £{0} or more (product exclusions apply), and free returns.',
  'very.onePersonContent.pageLink': 'Find out more about Click & Collect',
  'very.onePersonContent.modalHeading': 'Delivery and Returns',
  'very.onePersonContent.deliveryOptions': 'Delivery Options',
  'very.onePersonContent.clickCollect': 'Click & Collect',
  'very.onePersonContent.modelBody':
    'Orders will be delivered to one of 1,000s of pick-up points. Selected lines only, determined by size, weight, or whether delivered directly from one of our suppliers.',
  'very.onePersonContent.standardDelivery.clickCollect':
    'Standard Delivery: FREE - on orders of £{0} or more (£{1} charge for orders under £{0}) - Expected delivery within 3-5 days.',
  'very.onePersonContent.nextDayDelivery.clickCollect':
    'Next Day Delivery*: £{0} - Expected delivery the next working day.',
  'very.onePersonContent.homeDelivery': 'Home Delivery',
  'very.onePersonContent.standardDelivery': 'Standard Delivery: £{0} - Expected delivery within 3-5 days.',
  'very.onePersonContent.nextDayDelivery': 'Next Day Delivery*: £{0} - Expected delivery the next working day.',
  'very.onePersonContent.nominatedDayDelivery':
    'Nominated Day Delivery: £{0} - Book delivery up to 10 days in advance.',
  'very.onePersonContent.checkoutInfo':
    'Delivery dates and charges will be calculated at checkout, based on your order time and selection. All deliveries are made Monday to Saturday, between 7am and 9pm, excluding bank holidays. *Available for selected items.',
  'very.onePersonContent.returns':
    'Returns are free under our 28-day approval guarantee. You can arrange a return through My Account.',

  'veryie.onePersonContent.pageText':
    'FREE standard delivery with Click & Collect through Parcel Connect stores (product exclusions apply) and FREE returns.',

  'veryie.onePersonContent.pageLink': 'Find out more about Click & Collect',

  'veryie.onePersonContent.modalHeading': 'Delivery and Returns',

  'veryie.onePersonContent.modalBody':
    'For all delivery services, you will be able to view your estimated delivery date at checkout. Please add your Eircode to your address in My Account to help us make sure your orders get delivered to the right place.',

  'veryie.onePersonContent.freeClickCollect': 'FREE Standard Delivery with Click & Collect',

  'veryie.onePersonContent.freeClickCollectDetails':
    'Orders will be delivered to one of over 1000 Parcel Connect stores.',

  'veryie.onePersonContent.clickCollectExpress': 'Click & Collect Express',

  'veryie.onePersonContent.clickCollectExpressPrice': '€{0}',

  'veryie.onePersonContent.clickCollectExpressDetails': 'Order by 10pm Sunday to Thursday.',

  'veryie.onePersonContent.clickCollectExpressDelivery':
    "Expected delivery: 1-2 working days (Monday to Friday) for products stocked in our warehouse and 4 working days for products dispatched from a supplier's warehouse - view your estimated delivery date at checkout.",

  'veryie.onePersonContent.clickCollectStandard': 'Click & Collect Standard',

  'veryie.onePersonContent.clickCollectStandardPrice': 'FREE',

  'veryie.onePersonContent.clickCollectStandardDelivery':
    'Expected delivery: Within 4-7 working days (Monday to Friday).',

  'veryie.onePersonContent.standardDelivery': 'Standard delivery',

  'veryie.onePersonContent.standardDeliveryPrice': '€{0}',

  'veryie.onePersonContent.standardDeliveryDetails': 'Usually delivered within 4-7 working days (Monday to Friday).',

  'veryie.onePersonContent.expressDelivery': 'Express delivery',

  'veryie.onePersonContent.expressDeliveryPrice': '€{0}',

  'veryie.onePersonContent.expressDeliveryDetails': 'Order by 10pm Sunday to Thursday.',

  'veryie.onePersonContent.expressDeliveryDelivery':
    "Expected delivery: 1-2 working days (Monday to Friday) for products stocked in our warehouse and 4 working days for products dispatched from a supplier's warehouse - view your estimated delivery date at checkout.",

  'veryie.onePersonContent.returnsParcelConnect': 'To make a return using Parcel Connect',

  'veryie.onePersonContent.returnsDetails':
    "Returns to Very are FREE under our 28-day Approval Guarantee. It's easy to make your return: simply tick the box on the bottom of the advice note to indicate which item(s) you are returning. Fix the label to your parcel and drop it off at your nearest participating Parcel Connect convenience store.",

  'veryie.onePersonContent.returnsStoreLink':
    'To find a participating store near you, visit <a target="_blank" rel="noopener noreferrer" href="https://www.parcelconnect.ie/returns">Parcel Connect.</a>',

  'veryie.onePersonContent.returnsProof':
    "It's important to retain your proof of return or take a photo of your receipt, as this can be used to track your parcel.",

  'very.twoPersonContent.pageText': 'Delivery and returns',
  'very.twoPersonContent.pageLink': 'More info',
  'very.twoPersonContent.modalHeading': 'Delivery and Returns',
  'very.twoPersonContent.modalBody': 'Delivery of large and bulky items.',
  'very.twoPersonContent.modalBodyInfo':
    'Where available, you can book your delivery date when placing your order. If a confirmed date isn’t available for certain items, our delivery partner will contact you to arrange a suitable delivery date.',
  'very.twoPersonContent.homeDelivery': 'Home Delivery',
  'very.twoPersonContent.standardDelivery':
    'Standard Delivery: from £{0} - £{1} - Expected delivery within 3 days to 3 weeks.',
  'very.twoPersonContent.expressDelivery':
    'Express Delivery*: from £{0} - £{1} - Expected delivery within 2 working days.',
  'very.twoPersonContent.nextdayDelivery':
    'Next Day Delivery*: from £{0} - £{1} - Expected delivery the next working day.',
  'very.twoPersonContent.deliveryNotes':
    'Delivery dates and charges will be calculated at checkout based on your order time and selection. All deliveries are made Monday to Saturday, between 7am and 7pm, excluding bank holidays. *Available for selected items. Free delivery promotions only apply to qualifying items. Delivery charges will apply to additional items that do not qualify.',
  'very.twoPersonContent.returns': 'Returns',
  'very.twoPersonContent.returnsInfo':
    'Returns of large and bulky items are free under our 28-day approval guarantee. You can arrange a return by home collection through My Account, and you will be contacted within 3 days to choose an agreed collection date to suit you.',

  'veryie.twoPersonContent.pageText': 'This is a large item. There will be a delivery cost of €25.',

  'very.ffm.pageText': 'Delivered by <strong>{brand}</strong>',
  'very.ffm.pageLink': 'Find out more about delivery & returns',
  'very.ffm.modalHeading': 'Delivery and Returns',
  'very.ffm.modalBody':
    'This item will be delivered directly from the supplier, therefore the delivery and returns policy may be unique to them.',
  'very.ffm.deliveryInfo': 'Delivery & returns information',
  'very.ffm.deliveryCost': 'Delivery (£{0})',
  'very.ffm.deliveryTime': 'Within 5 working days',
  'very.ffm.returnsPolicy': 'Returns (FREE)',
  'very.ffm.returnsTime': 'Standard Policy - Within 28 days of receipt',
  'very.ffm.bfpoNote': 'Please note, delivery to a BFPO address is unavailable from some of our suppliers.',
  'very.ffm.policyNote':
    'Very.co.uk requires our suppliers to use the minimum standards required to meet our own delivery & returns policies.',

  'very.midRange.pageText': 'Delivery and returns',
  'very.midRange.pageLink': 'More info',
  'very.midRange.modalHeading': 'Delivery and Returns',
  'very.midRange.modalBody': 'Delivery Options',
  'very.midRange.homeDelivery': 'Home Delivery',
  'very.midRange.standardDelivery': 'Standard Delivery: £{0} - Expected delivery within 3-5 days.',
  'very.midRange.nextDayDelivery': 'Next Day Delivery*: £{0} - Expected delivery the next working day.',
  'very.midRange.nominatedDayDelivery': 'Nominated Day Delivery*: £{0} - Book delivery up to 10 days in advance.',
  'very.midRange.deliveryInfo':
    'Delivery dates and charges will be calculated at checkout based on your order time and selection.',
  'very.midRange.deliverySchedule':
    'All deliveries are made Monday to Friday, between 7am and 9pm, excluding bank holidays.',
  'very.midRange.selectedItemsNote': '*Available for selected items.',
  'very.midRange.returnsInfo':
    'Returns are free under our 28-day approval guarantee. You can arrange a return through My Account.',
};

export default deliveryContent;
